<template>
  <div>
    <ul class="nav nav-tabs" role="tablist" id="typeNav">
      <li role="presentation">
        <a href="#individual" aria-controls="home" role="tab" data-toggle="tab">Individuel</a>
      </li>
      <li role="presentation">
        <a href="#structure" aria-controls="profile" role="tab" data-toggle="tab">Structure</a>
      </li>
    </ul>
    <div class="tab-content">
      <input type="hidden" name="_token" :value="csrf">
      <input type="hidden" name="type" :value="type">
      <div role="tabpanel" class="tab-pane" id="individual">
        <div class="row">
            <v-input :errors="errors" :readonly="hasBilling" type="text" name="lastname" title="Nom *" class="col-md-6" v-model="customer.lastname"></v-input>
            <v-input :errors="errors" :readonly="hasBilling" type="text" name="name" title="Prenom *" class="col-md-6" v-model="customer.name"></v-input>
            <input-tel :errors="errors" name="phone" title="Numéro de téléphone" class="col-md-6" placeholder="Numéro de téléphone" v-model="customer.phone"></input-tel>
            <v-input :errors="errors" type="number" name="weight" title="Poids" class="col-md-6" v-model="customer.weight" unit="Kg" :required="false"></v-input>
            <div class="form-group col-md-6">
            <label for="birthdate">Date de naissance</label>
            <input-date name="birthdate" class="form-control datepicker" init-view="year" format="DD/MM/YYYY" v-model="customer.birthdate"></input-date>
            </div>
            <v-input :errors="errors" type="text" name="adress" title="Adresse" class="col-md-6" v-model="customer.adress" :required="false"></v-input>
            <v-input :errors="errors" type="email" name="email" title="Mail" class="col-md-6" v-model="customer.email" :required="false"></v-input>
            <v-input :errors="errors" type="text" name="comments" title="Commentaires" class="col-md-6" v-model="customer.comments" :required="false"></v-input>
        </div>
      </div>
      <div role="tabpanel" class="tab-pane" id="structure">
        <div class="row">
          <v-input :errors="errors" :readonly="hasBilling" type="text" name="lastname" title="Nom de la structure *" class="col-md-6" v-model="customer.lastname"></v-input>
          <input type="hidden" name="name" value=""><!--to remove name for struct-->
          <v-input :errors="errors" type="email" name="email" title="Mail *" class="col-md-6" v-model="customer.email"></v-input>
          <v-input :errors="errors" type="text" name="adress" title="Adresse" class="col-md-6" v-model="customer.adress" :required="false"></v-input>
          <v-input :errors="errors" type="text" name="siret" title="Siret" class="col-md-6" v-model="customer.siret" :required="false"></v-input>
          <input-tel :errors="errors" name="phone" title="Numéro de téléphone" class="col-md-6" placeholder="Numéro de téléphone" v-model="customer.phone"></input-tel>
          <v-input :errors="errors" type="text" name="comments" title="Commentaires" class="col-md-6" v-model="customer.comments" :required="false"></v-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'customerForm',
  props:{
    selectedCustomer: {
      type: Object,
      default: function(){return {}},
    },
    selectedHasBilling:{//if customer has billing, prevent changing firstname and lastname
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      errors: {},
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      type: (this.selectedCustomer&&this.selectedCustomer.hasOwnProperty("type")&&this.selectedCustomer.type!="")?this.selectedCustomer.type:"individual",
      customer:this.selectedCustomer,
      hasBilling:this.selectedHasBilling,
      pLastName:(this.selectedCustomer&&this.selectedCustomer.hasOwnProperty("lastname"))?this.selectedCustomer.lastname:""//store previous lastname
    }
  },
  watch: {
    customer: {
      deep:true,
      handler(){this.lastNameToUpper()}
    },
    type:function(){this.lastNameToUpper()}
  },
  mounted () {
    globalEventBus.$on('selectedCustomerforModify', (data)=>{//when dynamicly changing customer
      this.customer=data.customer
      this.type=(this.customer.hasOwnProperty('type')&&this.customer.type!="")?data.customer.type:"individual"
      this.hasBilling=data.hasBilling
      $('#typeNav a[href="#'+data.customer.type+'"]').tab("show")
    });
    Event.listen('errors', (e) => {
        this.errors = e
    })
    $('a[data-toggle="tab"]').on('shown.bs.tab',(e)=>{//toggle input when tab change
      this.toggleInputs($(e.target).attr('href').substring(1))
    })
    $('#typeNav a[href="#'+this.type+'"]').tab('show')
  },
  methods: {
    lastNameToUpper(){//Put lastName in uppercase if individual
      if(this.customer.lastname!=this.pLastname && this.type=="individual"){
        this.customer.lastname = this.customer.lastname.toUpperCase()
        this.pLastName = this.customer.lastname//remember new lastName
      }
    },
    toggleInputs(type=this.type){//disabling inputs that do not match the selected type (to prevent them from being submitted with the form)
      this.type=type
      let invertType=(type=="individual")?"structure":"individual"
      this.$nextTick(function(){
        $("input, textarea, select","#"+invertType).attr("disabled", true);
        $("input, textarea, select","#"+type).attr("disabled", false);
      })  
    }
  }
};
</script>